var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / CH") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-CH",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#FF0000",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12 L8.34103775,12 C8.1526878,12 8,11.8480797 8,11.6589622 L8,8.34103775 C8,8.1526878 8.15192032,8 8.34103775,8 L12,8 L12,4.34103775 C12,4.1526878 12.1519203,4 12.3410378,4 L15.6589622,4 C15.8473122,4 16,4.15192032 16,4.34103775 L16,8 L19.6589622,8 C19.8473122,8 20,8.15192032 20,8.34103775 L20,11.6589622 C20,11.8473122 19.8480797,12 19.6589622,12 L16,12 L16,15.6589622 C16,15.8473122 15.8480797,16 15.6589622,16 L12.3410378,16 C12.1526878,16 12,15.8480797 12,15.6589622 L12,12 Z",
    id: "Rectangle-78",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/CH.8e83a523b6d5bc7fae0bb3d8acaa8b02.svg";
export { ForwardRef as ReactComponent };